import { render, staticRenderFns } from "./KnowledgeGraphView.vue?vue&type=template&id=88d71f70&scoped=true&"
import script from "./KnowledgeGraphView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeGraphView.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeGraphView.vue?vue&type=style&index=0&id=88d71f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d71f70",
  null
  
)

export default component.exports